import { render, staticRenderFns } from "./MasterDataTemplateApp.vue?vue&type=template&id=07abf954&scoped=true"
import script from "./MasterDataTemplateApp.vue?vue&type=script&lang=js"
export * from "./MasterDataTemplateApp.vue?vue&type=script&lang=js"
import style0 from "./MasterDataTemplateApp.vue?vue&type=style&index=0&id=07abf954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07abf954",
  null
  
)

export default component.exports